<template>
  <el-dialog :title="stockName" :visible.sync="dialogTableVisible" custom-class="pub_dialog">
    <div class="preview">
    <div>股票代码：&nbsp;{{stockCode}}</div>
    <div>调仓价格：&nbsp;{{sectionStart}}--{{sectionEnd}}</div>
    <div>止&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;盈：&nbsp;{{takeProFit}}</div>
    <div>止&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;损：&nbsp;{{stopLoss}}</div>
    <div>题&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;材：&nbsp;{{themeName}}</div>
      <div class="reason-box">
        <div>备&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;注：</div>
      <div class="m">{{selectedReason}}</div>
      </div>
      <div class="source-box">
        <div class="w">机构来源：</div>
        <div>{{source}}</div>
      </div>
    <div>调仓日期：{{selectedDate}}</div>
    <div class="hidden" v-html="data"></div>
    </div>
  </el-dialog>
</template>

<script>
import {StockPool} from "../../api/news";

export default {
  name: "Preview",
  data() {
    return{
      dialogTableVisible: false,
      stockName: '',
      stockCode: '',
      sectionEnd: '',
      sectionStart: '',
      sectionReason: '',
      source: '',
      stopLoss: '',
      takeProFit: '',
      themeName: '',
      selectedDate: '',
      data:[]
    }
  },
  methods: {
    init(data){
      this.dialogTableVisible=true;
      //data是父组件弹窗传递过来的值，我们可以打印看看
      // console.log(data.stockCode);
      this.stockName = data.stockName
      this.stockCode = data.stockCode
      this.sectionStart = data.sectionstart
      this.sectionEnd = data.sectionend
      this.selectedReason = data.selectedreason
      this.source = data.source
      this.stopLoss = data.stoploss
      this.takeProFit = data.takeprofit
      this.themeName = data.themeName
      this.selectedDate = data.selecteddate
      // console.log(this.stockName);
      let query = {
        code: this.stockCode,
      };
      StockPool( query ).then(( response ) => {
        if(response.code === 2000){
          this.data = response.data
        }
      });
    },
  }
}
</script>

<style scoped>
.preview div{
  font-size: 16px;
  margin: 0 0 15px 0;
}
.reason-box{
  display: flex;
  line-height: 2em;
}
.m{
  margin-left: 5px!important;
}
.source-box{
  display: flex;
  line-height: 2em;
}
</style>



// WEBPACK FOOTER //
// src/components/common/preview.vue